import { render, staticRenderFns } from "./tiaoliify.vue?vue&type=template&id=002fa6d8&scoped=true&"
import script from "./tiaoliify.vue?vue&type=script&lang=js&"
export * from "./tiaoliify.vue?vue&type=script&lang=js&"
import style0 from "./tiaoliify.vue?vue&type=style&index=0&id=002fa6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002fa6d8",
  null
  
)

export default component.exports